import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarList, ListType } from '../../models/bar-list.model';

@Component({
  selector: 'app-list-entry',
  imports: [CommonModule],
  templateUrl: './list-entry.html',
  styleUrl: './list-entry.scss',
})
export class ListEntry {
  @Input() listEntry: BarList | null = null;
  @Output() selected = new EventEmitter<BarList>();

  imageLoaded = false;

  onImageLoad() {
    this.imageLoaded = true;
  }

  onClick() {
    if (this.listEntry) this.selected.emit(this.listEntry);
  }

  get listTypeLabel(): string {
    if (!this.listEntry?.type && this.listEntry?.type !== 0) return 'Pública';
    switch (this.listEntry.type) {
      case ListType.private:  return 'Privada';
      case ListType.shared:   return 'Compartida';
      case ListType.public:
      default:                return 'Pública';
    }
  }

  get listTypeColor(): string {
    if (!this.listEntry?.type && this.listEntry?.type !== 0) return 'public';
    switch (this.listEntry.type) {
      case ListType.private:  return 'private';
      case ListType.shared:   return 'shared';
      case ListType.public:
      default:                return 'public';
    }
  }

  get lastUpdateDate(): string {
    if (!this.listEntry?.lastUpdate) return '';
    return new Date(this.listEntry.lastUpdate).toLocaleDateString('es-ES');
  }
}
